import { Component, OnInit } from '@angular/core';
import { Data, AppService } from '../../../app.service';
import { Settings, AppSettings } from '../../../app.settings';
import { Country } from '../../../app.models';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';



// ********************************************** TOP MENU COMPONENT CLASS *********************************************
@Component({
  selector: 'app-top-menu',
  templateUrl: './top-menu.component.html'
})
export class TopMenuComponent implements OnInit {

  public currencies = this.appService.getCurrencies();
  public currency: any;
  public selectedCountry: Country;
  public countries: Country[];
  private country: Country;
  public settings: Settings;
  public data: Data;


  // -- FUNC Constructor
  constructor(public appSettings: AppSettings, public appService: AppService, private router: Router, public snackBar: MatSnackBar) {
    this.settings = this.appSettings.settings;
    this.data = this.appService.Data;
  }


  // -- FUNC Ng On Init
  ngOnInit() {

    // get countries
    this.getCountries();

    // if we already have a saved in defaults user currency id then use currency with this id 
    if (localStorage.getItem('currentCurrencyIdIsSaved') == 'Yes') {
      var savedCurrentCurrencyId = localStorage.getItem('currentCurrencyId');
      this.currency = this.currencies[Number(savedCurrentCurrencyId)];
    }
    // else if we didnt yet save it then use the default currency
    else {
      this.currency = this.currencies[0];
      this.data.user.currencyId = this.currency.id;
    }
  }


  // -- FUNC Get Countries
  public getCountries() {
    this.appService.getCountries().subscribe(data => {
      // check status and if it is ok then unpack received countries list
      if (data['status'] == 1) {
        //console.log("TRUE ON GET COUNTRIES " + JSON.stringify(data));
        this.countries = <Country[]>data['data']['country_data'];
      }
      else {
        //console.log("FALSE ON GET COUNTRIES " + JSON.stringify(data));
      }
    });
  }


  // -- FUNC Get Country Name
  private getCountryName(countryId: string) {
    
    // find user country in received countries array buy its id
    let userCountry = this.countries.filter(item => item.id == this.appService.Data.user.countryID)[0];

    if (userCountry) {
      return userCountry.countryRus;
    }
    else {
      return "СТРАНА"
    }
  }


  // -- FUNC Change Currency
  public changeCurrency(currency) {
    this.currency = currency;
    this.getRateForUserCurrency(this.currency);
  }


  // -- FUNC Change Country
  public changeCountry(country: Country) {

    this.selectedCountry = country;

    // check if cart list isn't empty and if it isn't then tell user that if he want to change a country then all products will be removed from the cart list 
    if (this.appService.Data.cartList.length > 0) {
      // Tell user that if he wants to proceed then the cart products will be removed
      if (confirm('Пожалуйста обратите внимание что при смене страны будет обнулен список уже добавленных в корзину товаров.')) {
        this.appService.Data.cartList = [];
        this.appService.Data.totalCartCount = 0;
        this.appService.Data.totalCartPrice = 0;

        this.reload(country);

      }
    }
    // if cart list is empty then just change country 
    else {

      this.reload(country);
    }
  }


  // -- FUNC Reload 
  private reload(country: Country) {

    this.appService.Data.user.countryID = country.id;

    for (var i = 0; i < this.countries.length; i++) {
      if (country.id == this.countries[i].id) {
        this.country = this.countries[i];
      }
    }

    if (this.router.url == '/') {
      if (String(this.appService.Data.user.iUserID) == "2121") {
        this.router.navigate(['/sign-in']);
      }
      else {
        this.router.navigate(['/account/information']);
      }
    }
    else {
      this.router.navigate(['']);
    }
  }


  // -- FUNC Get Rate For User Currency
  public getRateForUserCurrency(userCurrency: any) {
    this.appService.getRateForUserCurrency(userCurrency.code
    ).subscribe(data => {
      // check responce status
      if (JSON.stringify(data) != "{}" && data['CNY_' + userCurrency.code] != "" && data['CNY_' + userCurrency.code] != "null") {
        //console.log("TRUE ON GET CURRENCY RATE" + JSON.stringify(data));

        // save received currency data
        this.appService.Data.user.currencyRate = data['CNY_' + userCurrency.code]
        this.appService.Data.user.currencyId = userCurrency.id;
        localStorage.setItem('currentCurrencyIdIsSaved', 'Yes');
        localStorage.setItem('currentCurrencyId', userCurrency.id);
      }
      else {
        this.snackBar.open("Произошла ошибка при запросе о курсе валюты. Установлена валюта по умолчанию - ¥ Юань Кнр. Пожалуйста попробуйте сменить валюту еще раз.", '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 5000 });

        this.appService.Data.user.currencyRate = 1.0;
        this.appService.Data.user.currencyId = 0;
        localStorage.setItem('currentCurrencyIdIsSaved', 'Yes');
        localStorage.setItem('currentCurrencyId', "0");
        //console.log("FALSE ON GET CURRENCY RATE");
      }
    });
  }


  // -- FUNC Go To Profile
  public goToProfile() {
    // if user is not guest then move to the profile page 
    if (String(this.appService.Data.user.iUserID) != "2121") {
      this.router.navigate(['/account']);
    }
    // else if user is not a guest then tell him that he need to sign-in to proceed
    else {

      if (confirm('Приносим извинения но Вы не Авторизованы в приложении и поэтому не можете перейти к личному кабинету. Перейти на страницу авторизации?')) {
        this.router.navigate(['/sign-in']);
      }

    }
  }


  // -- FUNC Log Out
  private logOut() {
    // clear user data
    this.appService.Data.user = null;
    this.appService.isUserLoggedIn = false;
    localStorage.setItem('wasUserLoggedInBefore', 'No');
    localStorage.setItem('userEmail', "");
    localStorage.setItem('userPassword', "");

    // create initial user
    this.appService.createInitialUser();

    // move to the sign in page
    this.router.navigate(['/sign-in']);
  }

}
